module.exports = __webpack_public_path__ + "img/wxdp.b67846e8.png";